const authzType = {
    // authz call
    AUTHZ_CALL: "AUTHZ_CALL",
    AUTHZ_CALL_COMMIT: "AUTHZ_CALL_COMMIT",
    AUTHZ_CALL_ROLLBACK: "AUTHZ_CALL_ROLLBACK",
};
  
  export default authzType;